import type { ReviewableOrder } from '@src/orders/domain/ReviewableOrder';
import { useUpdateReviewableOrder } from '@src/orders/hooks/useReviewableOrder';
import type { FeesFormFields } from '@src/orders/schemas/ReviewOrderFormPermitFields';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useUpdateFees = ({ order }: { order: ReviewableOrder }) => {
  const { updateReviewableOrder } = useUpdateReviewableOrder();
  const { mutate: updateFees } = useMutation({
    mutationFn: ({ fees }: { fees: FeesFormFields }) =>
      OrdersClient.updateFees({
        orderId: order.id,
        fees,
      }),
    onSuccess: (updatedOrder) => {
      updateReviewableOrder({ updatedOrder });
    },
  });

  return {
    updateFees,
  };
};
